import { ButtonPosition } from '@/common/manager/position/button-position';
import { useEffect } from 'react';
import isFunction from 'lodash/isFunction';
import { calculateTextExprValue, executeFunction } from '@/common/util/util';
export const config = {
    value: 'tableLoop',
    position: [ButtonPosition.tableToolArea, ButtonPosition.tableBatchArea],
    getRenderDom: (config) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            const { options, tableRef, isDesign, state } = config || {};
            const { active, interval, keepPagination, stopLoop } = options;
            const isActive = isFunction(active)
                ? executeFunction(active, {}, state)
                : active;
            let loopId;
            function doStopLoop() {
                const stop = calculateTextExprValue(stopLoop, {
                    recordDataSource: {},
                    state,
                });
                if (stop === true && loopId) {
                    clearInterval(loopId);
                }
            }
            function loopOneTable() {
                loopId = setInterval(() => {
                    if (keepPagination === true) {
                        tableRef?.tableLoad()?.();
                    }
                    else {
                        tableRef?.load?.();
                    }
                    tableRef
                        ?.getRemoteOperation?.()
                        ?.current?.innerInfo?.setLoading?.(false);
                    doStopLoop();
                }, interval * 1000);
            }
            if (!isDesign &&
                isActive &&
                tableRef?.load &&
                typeof interval === 'number' &&
                interval >= 2) {
                loopOneTable();
            }
            return () => {
                if (loopId !== undefined) {
                    clearInterval(loopId);
                }
            };
        }, []);
        return null;
    },
};
